import { IAppConfig } from '@/Core/Contracts/Configs/IAppConfig'

export const AppConfig: IAppConfig = {
    /**
     * URL сторінок
     */
    authPageUrl: '/',
    forgotPasswordPageUrl: '/public/forgot-password',
    /**
     * URL бекенду
     */
    backendUrl: import.meta.env['VITE_BACKEND_URL'] || '',
    mercureUrl: import.meta.env['VITE_MERCURE_URL'] || '',
    /**
     * URL Rest запитів
     */
    restLoginUrl: '/services/auth/login?centrifugo=true',
    restUserMe: '/services/auth/me',
    restForgotPasswordUrl: '/services/users/password_reset_by_email',
    restResetPasswordUrl: '/services/users/{token}/password_reset',
    restRefreshTokenUrl: '/services/auth/refresh_token?centrifugo=true',
    restUserOptionUrl: '/services/user/options',
    restResolvedUserOptionUrl: '/services/user/options/resolved',
    restOptionUrl: '/services/options',
    searchUrl: '/services/typesense/multi_finder',
    /**
     * Локалізація
     */
    defaultLocale: import.meta.env['VITE_DEFAULT_LOCALE'] ?? 'uk_UA',
    currentLocale: import.meta.env['VITE_DEFAULT_LOCALE'] ?? 'uk_UA',

    /**
     * Дата та час
     */
    dateDefaultFormat: 'YYYY-MM-DD',
    datetimeDefaultFormat: 'YYYY-MM-DD HH:mm',
    timezone: 'Europe/Kyiv',
    /**
     * PWA-режим водія
     */
    pwa: {
        enabled: true,
        offlineSync: true,
    },
}
